/**
 * Padrão de rotas do app admin (URLs em inglês, kebab-case):
 *
 * - Recursos no plural: `reports`, `categories`
 * - Escopos aninhados: `reports/active`, `reports/archived`
 * - Detalhe por id: `/:uuid` ou `/details/:id` (CRUD de categorias)
 * - Ações CRUD: `list`, `create`, `edit/:id`, `details/:id`
 * - Rotas de sistema: `profile`, `settings`, `access-denied`, `dashboard`
 *
 * Labels e títulos de página permanecem em pt-BR; apenas os segmentos de URL são em inglês.
 */
export const ADMIN_ROUTE_PATHS = {
  dashboard: '/dashboard',
  activeReports: '/reports/active',
  archivedReports: '/reports/archived',
  categories: '/categories',
  categoriesList: '/categories/list',
  categoryCreate: '/categories/create',
  notifications: '/notifications',
  activityLogs: '/activity-logs',
  users: '/users',
  profile: '/profile',
  settings: '/settings',
  accessDenied: '/access-denied',
} as const;

export type AdminRoutePath = (typeof ADMIN_ROUTE_PATHS)[keyof typeof ADMIN_ROUTE_PATHS];

export function adminActiveReportDetailsPath(uuid: string): string {
  return `${ADMIN_ROUTE_PATHS.activeReports}/${uuid}`;
}

export function adminArchivedReportDetailsPath(uuid: string): string {
  return `${ADMIN_ROUTE_PATHS.archivedReports}/${uuid}`;
}

export function adminCategoryEditPath(id: string): string {
  return `${ADMIN_ROUTE_PATHS.categories}/edit/${id}`;
}

export function adminCategoryDetailsPath(id: string): string {
  return `${ADMIN_ROUTE_PATHS.categories}/details/${id}`;
}

/** Comandos para `Router.navigate()`. */
export const ADMIN_ROUTE_COMMANDS = {
  dashboard: [ADMIN_ROUTE_PATHS.dashboard] as const,
  activeReports: [ADMIN_ROUTE_PATHS.activeReports] as const,
  archivedReports: [ADMIN_ROUTE_PATHS.archivedReports] as const,
  categoriesList: [ADMIN_ROUTE_PATHS.categoriesList] as const,
  categoryCreate: [ADMIN_ROUTE_PATHS.categoryCreate] as const,
  notifications: [ADMIN_ROUTE_PATHS.notifications] as const,
  activityLogs: [ADMIN_ROUTE_PATHS.activityLogs] as const,
  users: [ADMIN_ROUTE_PATHS.users] as const,
  activeReportDetails: (uuid: string) => [ADMIN_ROUTE_PATHS.activeReports, uuid] as const,
  archivedReportDetails: (uuid: string) => [ADMIN_ROUTE_PATHS.archivedReports, uuid] as const,
  categoryEdit: (id: string) => [ADMIN_ROUTE_PATHS.categories, 'edit', id] as const,
  categoryDetails: (id: string) => [ADMIN_ROUTE_PATHS.categories, 'details', id] as const,
} as const;
